import { Button, makeStyles, Theme } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { FC, ReactNode } from 'react'

const useStyles = makeStyles<Theme>((theme) => {
  const nonDisabledButton = {
    border: `1px solid ${theme.palette.grey[500]}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.grey[800],
  }

  const activeColor = theme.palette.menu.selected

  const activeButton = {
    borderColor: activeColor,
    color: activeColor,
    fontWeight: theme.typography.fontWeightBold,
  }

  const disabledButton = {
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[200],
    '& span': {
      color: theme.palette.grey[400],
    },
  }

  return {
    button: {
      height: '54px',
      width: '100%',
      minWidth: '88px',
      paddingLeft: theme.spacing(2),

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',

      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'pointer',

      borderRadius: theme.shape.borderRadius,
      ...nonDisabledButton,

      '&:hover': {
        ...activeButton,
      },
    },

    icon: {
      marginRight: theme.spacing(1),
      display: 'flex',
    },

    active: {
      ...activeButton,
    },

    disabled: {
      cursor: 'not-allowed',
      ...disabledButton,

      '&:hover': {
        ...disabledButton,
      },
    },
  }
})

type LeanQrButtonProps = {
  onClick: () => void
  active: boolean
  name: string
  label: ReactNode
  icon?: ReactNode
  disabled?: boolean
}
export const LeanQrButton: FC<LeanQrButtonProps> = ({ onClick, active, name, label, icon, disabled }) => {
  const styles = useStyles()

  return (
    <Button
      disabled={disabled}
      name={name}
      className={cn({
        [styles.button]: true,
        [styles.active]: active && !disabled,
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span>{label}</span>
    </Button>
  )
}
